export default __webpack_public_path__ + "static/media/single-project-page-04-img05.1d3921f1.jpg";